export const TARIFFICATOR_BILLING_PRODUCT_ID = 'tarifficator';

export interface OfferPlacementAnalytics<TData> {
    setData(this: void, data: TData): void;
    showed(this: void): void;
    navigated(this: void): void;
    succeeded(this: void): void;
}
